import { FC } from "react"
import { ListPropiedades } from "./PropiedadLista"

export const PropiedadCaracteristicaBody: FC = () => {
    return (
        <ListPropiedades />
    )
}